import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import Player from "source/app/domain/Player";
import { GetDefaultKeyValue } from "source/app/infrastructure/Data/KeyValues/defaultKeyValue";
import { ResetCICOValue } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Helpers/ResetCICOValue";
import { MathUtils } from "source/app/services/Math/MathUtils";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { TodaysValueWithHistory } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/CICO/Helpers/TodaysValueWithHistory";
import { ChangeCICOValue } from "../Helpers/ChangeCICOValue";

export function CICOProtein({
    timeCompletePercent,
}: {
    timeCompletePercent: number;
}) {
    const [keyValue, setKeyValue] = React.useState<IKeyValue>(
        GetDefaultKeyValue()
    );

    const [increaseBy, setIncreaseBy] = React.useState<number>(0);

    ShareState(ESharedFunction.CICO_protein, keyValue, setKeyValue);

    const todaysProteinRecorded =
        keyValue.value === GetDefaultKeyValue().value
            ? 0
            : Number.parseInt(keyValue.value);

    const todaysProtein =
        todaysProteinRecorded + MathUtils.IfIsNaN(increaseBy, 0);

    const proteinPercent = Math.floor(
        (todaysProtein / Player.targetProtein) * 100
    );

    const proteinRemaining = Math.floor(
        (timeCompletePercent / 100) * Player.targetProtein - todaysProtein
    );

    const proteinRemainingText =
        proteinRemaining > 0 ? `| +${proteinRemaining}` : ``;

    const delta = proteinPercent - timeCompletePercent;
    const deltaText = delta >= 0 ? `+${delta}` : delta;

    return (
        <div
            style={{
                textAlign: "center",
                margin: "10px",
                borderRadius: "6px",
                background: "rgb(171 115 46 / 15%)",
                padding: "10px",
                flexGrow: 1,
            }}
        >
            <div>
                Protein:
                <span style={{ margin: `0px 5px` }}>
                    <TodaysValueWithHistory
                        {...{
                            todaysValue: todaysProtein,
                            keyValue,
                            sharedFunction: ESharedFunction.CICO_protein,
                        }}
                    />
                </span>
                g |
                <span
                    style={{
                        marginLeft: `10px`,
                        color:
                            proteinPercent >= 100
                                ? `rgb(142 203 17)`
                                : `inherit`,
                    }}
                >
                    {proteinPercent}% {proteinRemainingText}
                </span>
                <ResetCICOValue
                    {...{
                        sharedFunction: ESharedFunction.CICO_protein,
                        keyValue,
                    }}
                />
            </div>
            <div
                style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                }}
            >
                <div>
                    <span>
                        Protein
                        <span
                            style={{
                                marginLeft: `10px`,
                                color:
                                    delta > 0 ? `rgb(142 203 17)` : `inherit`,
                            }}
                        >
                            {deltaText}%
                        </span>
                    </span>
                </div>
            </div>
            <ChangeCICOValue
                {...{
                    increaseBy,
                    setIncreaseBy,
                    sharedFunction: ESharedFunction.CICO_protein,
                    keyValue
                }}
            />
        </div>
    );
}
